import React from "react";
import styled from "styled-components";
import ProgramNoteTextArea from "../Component/ProgramNoteTextArea";

export default function ProgramNoteBox(props) {
  const {
    isEdit,
    columnTitle,
    explanation,
    boxText,
    boxColor,
    value,
    setValue,
    placeholder
  } = props;

  return (
    <TopLevelWrapper>
      <ColumnBoxWrapper>
        <ColumnBox>
          <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#2F2F32' cursor='default'>{columnTitle}</Text>
        </ColumnBox>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#6DD49E' cursor='default'>{explanation}</Text>
      </ColumnBoxWrapper>
      <ViewBox>
        {/* <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor='default'>{explanation}</Text> */}
        <TextAreaWrapper border={isEdit ? '2px dashed #CBCBCB' : '2px solid #CBCBCB'}>
          <DivisionBox backgroundColor={boxColor}>
            <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' cursor='default'>{boxText}</Text>
          </DivisionBox>
          <ProgramNoteTextArea 
            isEdit={isEdit}
            value={value} 
            setValue={setValue} 
            placeholder={placeholder}/>
        </TextAreaWrapper>
      </ViewBox>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const ColumnBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const ColumnBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 5px 10px;
  
  border-radius: 5px 5px 0px 0px;
  background-color: #6DD49E;
`;

const ViewBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 15px 15px 20px 15px;

  width: calc(100% - 30px);

  gap: 10px;

  border-radius: 0px 10px 10px 10px;
  background-color: #17171B;
`;

const TextAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: calc(100% - 2px);

  border: ${props => props.border};
  border-radius: 5px;
  background-color: #2F2F32;
`;

const DivisionBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 15px;

  height: 24px;

  border-radius: 4px 0px 5px 0px;
  background-color: ${props => props.backgroundColor};
`;

const Text = styled.div`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
